import React, { useState, useEffect } from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

import isEmpty from 'lodash.isempty';
import loadable from '@loadable/component';

import { getItemWebUrl, timeDiff } from '../utilities/helpers';
import AmplitudeHelperClass from '../utilities/amplitudeHelper';
import { PUBLIC_IMG_URL } from '../utilities/endpoints';
const ContentTag = loadable(() => import(/* webpackChunkName: "ContentTag" */ '../reusable-components/ContentTag'));

const amplitudeHelper = new AmplitudeHelperClass();

const ContentBox = ({ data, keyData, type }) => {
    const [imageLoaded, setImageLoaded] = useState(false);

    useEffect(() => {
        setTimeout(() => {
            if (!imageLoaded) {
                setImageLoaded(true);
            }
        }, 2000);

    }, [imageLoaded]);

    const amplitudeTrack = () => {
        amplitudeHelper.trackEvent(`clicked featured ${type}`);
    };

    const tempKey = "featured-content-" + keyData;

    if (data) {
        if (keyData !== 0) {
            return (
                <div className="content-item-row" key={tempKey} lang={data.lang}>
                    <div className="row">
                        <div className="col-4">
                            <a
                                href={`/${data.itemUrl}`}
                                onClick={() => amplitudeTrack()}
                                aria-label={`${data.name}-Link`}
                            >
                                <img
                                    src={data.image}
                                    loading="eager"
                                    alt={`${data.name}-Image`}
                                    fetchPriority='high'
                                />
                            </a>
                        </div>
                        <div className="col-8 content-item-row-text">
                            <div className="content-item-row-title">
                                <a href={`/${data.itemUrl}`} onClick={() => amplitudeTrack()}>
                                    {data.title}
                                </a>
                            </div>
                            <div className="hidden-md-up">
                                <p className="content-item-row-newsbody">{data.body}</p>
                            </div>
                            <ContentTag tagdata={data} type={type} displayMax={2} />
                            <div className="content-item-row-secondary">
                                {type == "news" ? "Posted" : "Released"} {timeDiff(data.time)} ago
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            // featured focus - 1'st item
            const transparency = type === "news" ? 0.6 : 0.2;
            let overlayStyles = `linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, ${transparency})), url(${data.image})`;

            return (
                <a
                    className="content-featured-box image-focus"
                    href={`/${data.itemUrl}`}
                    key={tempKey}
                    onClick={() => amplitudeTrack()}
                >
                    {!imageLoaded && (
                        <Skeleton height={'100%'} />
                    )}
                    {/* img element ensures that featured-overlay div takes the same aspect ratio as the image, that's why ${data.image} is there twice */}
                    <img
                        src={data.image}
                        alt={`${data.name}-Image`}
                        style={{
                            display: imageLoaded ? 'block' : 'none',
                        }}
                        onLoad={() => setImageLoaded(true)}
                    />
                    <div
                        className="featured-overlay"
                        style={{ backgroundImage: overlayStyles }}
                    ></div>
                </a>
            );
        }
    }
    return null;
};

const FeaturedContent = ({ type, data }) => {

    const parseFeaturedData = () => {
        if (data && data.length > 0) {
            let parsedData = data;
            let displayData = [];
            parsedData.map(function (item, i) {

                if (item.body !== undefined && item.body !== null) {
                    item.body = item.body.replace(/<\/?[^>]+(>|$)/g, "")
                    item.body = item.body.replace(/&nbsp;/g, ' ')
                    item.body = item.body.replace(/&#39;/g, "'")
                    item.body = item.body.replace(/&quot;/g, '"')
                    item.body = item.body.replace(/&rsquo;/g, "’")
                    if (item.body.length > 200) {
                        item.body = item.body.substr(0, 200)
                        item.body = item.body.substr(0, item.body.lastIndexOf(' ')) + ' ...'
                    }
                }

                let date = new Date(item.published_at)
                let options = {
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                    weekday: 'short',
                    hour: 'numeric',
                    minute: 'numeric',
                }
                item.time = date.toLocaleString("en-US", options)

                if (!isEmpty(item.image_data)) {
                    item.image = encodeURI(item.image_data.path)
                    item.altImg = item.name;
                } else {
                    item.image = `${PUBLIC_IMG_URL}/bg/job_banner.jpeg`
                    item.mime = 'image/jpeg';
                }

                if (item.source) {
                    item.site = item.source.split('/');
                    if (item.site[0] === 'http:' || item.site[0] === 'https:') {
                        item.site = item.site[2];
                    } else {
                        item.site = item.site[0];
                    }
                    item.site = item.site.replace('www.', '');
                }

                if (type === 'research') {
                    item.title = item.name
                    item.itemUrl = getItemWebUrl('research', item.id, item.code)
                } else {
                    item.itemUrl = getItemWebUrl('news', item.id, item.code)
                }

                displayData[i] = item;

            });
            return displayData

        }
    }

    const parsedData = parseFeaturedData()

    return (
        <div className="row" style={{ position: 'relative' }} key="FC">
            <div className="col-md-7 col-lg-6 d-lg-block d-md-none">
                {parsedData && <ContentBox data={parsedData[0]} keyData={0} type={type} key={0} />}
            </div>
            <div className="col-lg-6 featured-article-list">
                {parsedData && parsedData.map((list, j) => {
                    if ((j == 1) || (j == 2)) {
                        return (
                            <>
                                <ContentBox data={list} keyData={j} type={type} key={j} />
                                <hr />
                            </>
                        );
                    } else if (j == 3) {
                        return (<ContentBox data={list} keyData={j} type={type} key={j} />);
                    }
                })}
            </div>
        </div>
    )
}

export default FeaturedContent;
